import { Breakpoints } from '@material-ui/core/styles/createBreakpoints';

export const breakpoints: Partial<Breakpoints> = {
  values: {
    xs: 0, // used as SVP
    sm: 600, // used as MVP
    md: 768, // used as LVP
    lg: 1024, // default MUI
    xl: 1280, // default MUI
  },
};
